import { useEffect, useState } from 'react';

/**
 * The draft's wait, made legible, after One Step Ahead's AskProgress. The draft is one
 * request, so the steps advance on elapsed time against the pipeline's real order — never a
 * percentage — and the last step stays current however long it takes.
 */
const STEPS = ['Loading your course’s standards', 'Drafting units across your weeks', 'Checking every standard has a place'] as const;
const MARKS: readonly number[] = [0, 8000, 45000];
const SLOW_AFTER = 70000;

export function DraftProgress({ now = Date.now }: { now?: () => number }) {
  const [elapsed, setElapsed] = useState(0);
  useEffect(() => {
    const startedAt = now();
    const timer = window.setInterval(() => setElapsed(now() - startedAt), 500);
    return () => window.clearInterval(timer);
  }, [now]);
  const current = MARKS.reduce((at, mark, index) => (elapsed >= mark ? index : at), 0);
  return <div className="ask-overlay">
    <div className="ask-progress" role="status" aria-label="Drafting your year">
      <p className="ask-progress-title">Drafting your year<span className="title-dot">.</span></p>
      <ol>
        {STEPS.map((step, index) => <li key={step} className={index < current ? 'done' : index === current ? 'current' : 'waiting'}>
          <span className="ask-progress-mark" aria-hidden="true">{index < current ? '✓' : '○'}</span>
          <span>{step}</span>
        </li>)}
      </ol>
      <p className="muted">{elapsed >= SLOW_AFTER ? 'Still going. A full course is a lot of standards.' : 'This usually takes under a minute.'}</p>
    </div>
  </div>;
}
